import { render, staticRenderFns } from "./CardResultFailFromIdcardLock.vue?vue&type=template&id=70f7e3aa&scoped=true&"
import script from "./CardResultFailFromIdcardLock.vue?vue&type=script&lang=js&"
export * from "./CardResultFailFromIdcardLock.vue?vue&type=script&lang=js&"
import style0 from "./CardResultFailFromIdcardLock.vue?vue&type=style&index=0&id=70f7e3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f7e3aa",
  null
  
)

export default component.exports